import http from '../common/http';
import env from '../envConfig';
import { getHeader } from '../auth/authManager';
import { responseHandler } from '../common/responseHandler';
import moment from 'moment';

export const obterExtratoBeneficios = async (dados: any) => {
  let url = env.urlApi + `/transacional-api/v1/extrato/${dados.nuFamiliar}?`;

  url += `tipoPerfil=${dados.tipoPerfil.codigo}&`
  url += `cpf=${dados.cpf}&`
  url += `tipoConsulta=${dados.tipoConsulta}&`
  url += `dataInicial=${moment(dados.dataInicial).format('YYYYMM')}&`;
  url += `dataFinal=${moment(dados.dataFinal).format('YYYYMM')}`;

  const headers = getHeader();
  const response = await http.get(url, { headers });
  return responseHandler(response);
};

export const obterTiposBeneficiosDisponiveis = async (dados: any) => {
  let url = env.urlApi + `/transacional-api/v1/extrato/tiposBeneficiosDisponiveis/${dados.nuFamiliar}?`;

  url += `tipoPerfil=${dados.tipoPerfil.codigo}&`
  url += `cpf=${dados.cpf}`;

  const headers = getHeader();
  const response = await http.get(url, { headers });
  return responseHandler(response);
};

export const obterExtratoConsignado = async (dados: any) => {
  let url = env.urlApi + `/transacional-api/v1/extrato/consignacoes/${dados.nuFamiliar}`;

  const headers = getHeader();
  const response = await http.get(url, { headers });
  return responseHandler(response);
};
